<div class="container-fluid leave-sz-confirm-container">
  <div class="top-row">
    <h1 class="confirm-modal-title">Leave Schoolzilla?</h1>
    <button class="btn btn-link close-x-btn" (click)="closeModal()">X</button>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class="description-text">
        <p class="modal-description-text">
          Clicking "Go" will take you to a link outside of Schoolzilla ({{
            data.url
          }})
        </p>
        <p class="modal-description-text">Do you want to proceed?</p>
      </div>
      <mat-checkbox class="mosaic-material-theme" [(ngModel)]="hideModalChecked"
        >Don't show this message again</mat-checkbox
      >
    </div>
  </div>
  <div class="row btn-row">
    <button
      class="btn btn-lg btn-default close-modal-btn"
      (click)="closeModal()"
    >
      Cancel
    </button>
    <button
      class="btn btn-lg save-changes-btn"
      [mat-dialog-close]="{
        leaveMosaic: true,
        hideModalChecked: hideModalChecked
      }"
    >
      Go
    </button>
  </div>
</div>
